/**
 * Every column of `ai_models` a signed-in session may read. `api_credentials` holds the provider
 * API key and is not in the list: the database withholds it from every session role, so a
 * `select('*')` on the table is refused. A platform admin learns whether a key is set through the
 * `get_ai_model_credential_status` function and changes it through `set_ai_model_credentials`.
 */
export const AI_MODEL_COLUMNS = 'id, platform_admin_id, provider, model_name, model_config, capabilities, pricing, context_window, is_active, is_default, created_at, updated_at, has_vision, status, replacement_model_id, access_tier, dev_only' as const;
